import { render, staticRenderFns } from "./BulkAddResources.modal.vue?vue&type=template&id=7ecc196c"
import script from "./BulkAddResources.modal.vue?vue&type=script&lang=ts"
export * from "./BulkAddResources.modal.vue?vue&type=script&lang=ts"
import style0 from "./BulkAddResources.modal.vue?vue&type=style&index=0&id=7ecc196c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports